// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tWxZ5","footer":"styles_footer__1zx_2","passCodeTooltip":"styles_passCodeTooltip__37Npn"};